import { MerchantUserType } from "@/models/club";
import {
  Anchor,
  Divider,
  Group,
  Skeleton,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";

type Props = {
  merchantServicesLength: number;
  merchantUserType: MerchantUserType;
  userId: number;
  isLoading: boolean;
};
function ProfileDetailSetting({
  merchantServicesLength,
  merchantUserType,
  userId,
  isLoading,
}: Props) {
  const navigate = useNavigate();
  return (
    <Stack gap="xl">
      <Stack>
        <Group justify="space-between">
          <Title order={4}>خدمات</Title>
          <Anchor
            onClick={() =>
              isLoading
                ? null
                : navigate(
                    `/dashboard/teams/teamMembers/editServices/${userId}`
                  )
            }
          >
            {isLoading ? (
              <Skeleton w="50px" height={20} />
            ) : (
              <Text size="xs">ویرایش</Text>
            )}
          </Anchor>
        </Group>
        <Stack gap="5">
          <Text fw="500" size="sm">
            {" "}
            تعداد خدمات انجام دهنده
          </Text>
          {isLoading ? (
            <Skeleton w="100px" height={20} />
          ) : (
            <Text c="dark.5" size="sm">
              {merchantServicesLength} خدمت
            </Text>
          )}
        </Stack>
      </Stack>
      <Divider />
      <Stack>
        <Group justify="space-between">
          <Title order={4}>تنظیمات</Title>
          <Anchor>
            <Text
              size="xs"
              onClick={() =>
                isLoading
                  ? null
                  : navigate(
                      `/dashboard/teams/teamMembers/edit/${userId}?tab=3`
                    )
              }
            >
              {isLoading ? (
                <Skeleton w="50px" height={20} />
              ) : (
                <Text size="xs">ویرایش</Text>
              )}
            </Text>
          </Anchor>
        </Group>
        <Stack gap="5">
          <Text fw="500" size="sm">
            {" "}
            سطح دسترسی{" "}
          </Text>

          {isLoading ? (
            <Skeleton w="100px" height={20} />
          ) : (
            <Text c="dark.5" size="sm">
              {merchantUserType === MerchantUserType.Value2
                ? "آرایشگر"
                : "دسترسی کامل"}
            </Text>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}

export default ProfileDetailSetting;
